import PropTypes from 'prop-types'
import { CustomInput, UncontrolledTooltip } from 'reactstrap'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'

/**
 * Displays a single row with a radio button for a single Payment Method
 */
const CustomerCheckoutPaymentMethod = ({ paymentMethod, isSelected, disabled = false, handleSelect }) => (
  <div className='d-flex align-items-center'>
    <CustomInput
      className='text-capitalize flex-fill'
      id={ `checkout-payment-method-radio-${paymentMethod.id}` }
      type='radio'
      checked={ isSelected }
      disabled={ disabled }
      // empty function so we dont get uncontrolled error
      onChange={ () => { } }
      onClick={ () => handleSelect(paymentMethod) }
      label={
        <div className='d-flex align-items-center'>
          <div>
            <img
              className='checkout__input-label-img pr-3'
              style={{ width: '5rem' }}
              src={ `${WEB_URL_CONSTANTS.HOMEPAGE}/${paymentMethod.logo_url}` }
            />
          </div>
          <div className='small'>
            { paymentMethod.name }
          </div>
        </div>
      }
    />
    <div>
      <i
        className="fas fa-info-circle checkout__tooltip"
        id={ `UncontrolledTooltipExample-${paymentMethod.id}` }
      />
      <UncontrolledTooltip
        placement="top"
        target={ `UncontrolledTooltipExample-${paymentMethod.id}` }
      >
        { paymentMethod.description }
      </UncontrolledTooltip>
    </div>
  </div>
)

CustomerCheckoutPaymentMethod.propTypes = {
  paymentMethod: PropTypes.shape({
    id             : PropTypes.number.isRequired,
    name           : PropTypes.string.isRequired,
    description    : PropTypes.string.isRequired,
    url            : PropTypes.string.isRequired,
    category       : PropTypes.string.isRequired,
    category_label : PropTypes.string.isRequired,
    logo_url       : PropTypes.string.isRequired,
    rate           : PropTypes.shape({
      absolute_value   : PropTypes.string,
      calculation_type : PropTypes.string.isRequired,
      percentage_value : PropTypes.string
    }).isRequired
  }),
  isSelected   : PropTypes.bool.isRequired,
  disabled     : PropTypes.bool,
  handleSelect : PropTypes.func.isRequired
}

export default CustomerCheckoutPaymentMethod